import type { Products } from "../types"

export const products: Products = new Map([
  [
    "re7-labs-tac",
    {
      name: "Re7 Labs Cluster",
      entity: "re7-labs",
      vaults: [
        "0x27324c0d445f94550b53936dBAB7fD168634f192",
        "0xc7F25f1c8FDB86DE3d14152034de4EB8B71eEC78",
        "0x4ac2478eb1DDf574b0ffF297a25BB496af1fA207",
        "0x2eF66758705426e7BF598669AEf23eE9b9CC3088",
        "0x15794A8e1708511DABeC3d356aDDbE7128E90D8F",
        "0xE2E106a9Ec7bc7F5dcDf5a20Ea007b833cCf4f1f",
        "0xA88869168951a3eB12484814e7A6Ea3f0aC70e69",
        "0x0Fa94ABEC53c176f9bf1Ae6c871a1214D8aECec8",
        "0x2C58807B0556fE2E4b10DBf8eC40c1e900022c51",
      ],
    },
  ],
  [
    "edge-capital-tac",
    {
      name: "Edge UltraYield Cluster",
      entity: "edge-capital",
      vaults: [
        "0xdD6EaEf38F94d4724124cEc14c819818714537Ff",
        "0x2c8a93667D8909FA8F0c24F2c571C9163D3fB77A",
        "0x72D0e285166B0dDe84eE247c16e45979725D1399",
        "0x994a7766a0e658098cA01A1ADf114abD29e5629e",
        "0x73475c15FE4Cb39AD0c58Cb520E7A5771Ae8fC44",
        "0x522e6437B80B11C10AaFDB321c3610B85127E4CD",
        "0x41068B2c61d535a370E39415E090eC2100B57934",
        "0xf055eaa0802Fd2A1A6320D2308925831092A534C",
        "0xCc69e827EA1eB78dA3eD1543256d3916B4078620",
        "0xd5fFE1231F5610C68dD67eD3b870541D0A63aF50",
        "0xE82A5eD2d6E0423317F2a7FdB3B21215411791e0",
        "0xcAA9c74f87D31bC280AF5666BdC868DEe2064fE8",
        "0x921209493da603056De9B9a46eCE14b996a75088",
      ],
    },
  ],
])
